import { Navigate } from "react-router-dom"
import { useAuth } from "./AuthProvider"

function RequireAuth({
  children,
  requiredRole,
}: {
  children: React.ReactNode
  requiredRole?: "ADMIN" | "OPERATOR"
}) {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" replace />
  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to="/dashboard" replace />
  }
  return <>{children}</>
}

export default RequireAuth
